/**
 * @generated SignedSource<<c42ad10b26a918d4598179f1158d55da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuHighlightedPromotion_ProductSku$data = {
  readonly id: string;
  readonly promotions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly highlight: boolean | null;
      };
    }>;
  } | null;
  readonly " $fragmentType": "ProductSkuHighlightedPromotion_ProductSku";
};
export type ProductSkuHighlightedPromotion_ProductSku$key = {
  readonly " $data"?: ProductSkuHighlightedPromotion_ProductSku$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuHighlightedPromotion_ProductSku">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuHighlightedPromotion_ProductSku",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "addresses",
          "variableName": "addresses"
        }
      ],
      "concreteType": "PromotionConnection",
      "kind": "LinkedField",
      "name": "promotions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PromotionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Promotion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "highlight",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductSku",
  "abstractKey": null
};
})();

(node as any).hash = "2dd6041fa9c054396e0b7b05323360c9";

export default node;
